import { Button, Input, Radio } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import CreateProfileCardWrapper from "../../components/common/CreateProfileCardWrapper";
import { setInfoContent } from "../../redux/slices/common_slice";
import "./OnboardingPage.css";

const NameAgePage = ({ formik }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const ageRanges = [
    { label: t("aboutYou.step1.ques2.optionLabel1"), value: "Up to 18" },
    { label: "19-24", value: "19-24" },
    { label: "25-40", value: "25-40" },
    { label: "41-54", value: "41-54" },
    { label: t("aboutYou.step1.ques2.optionLabel2"), value: "55 +" },
  ];
  return (
    <>
      <CreateProfileCardWrapper>
        <h5>{t("aboutYou.step1.ques1.title")}</h5>
        <div className="custom-common-select-box custom-input-style">
          <Input
            className={
              formik.touched.firstName && formik.errors.firstName
                ? "error-fill"
                : formik.values.firstName
                ? "data-fill"
                : ""
            }
            style={{
              paddingLeft: "20px",
            }}
            placeholder={t("aboutYou.step1.ques1.placeholder")}
            name="firstName"
            value={formik.values.firstName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            suffix={
              <img
                src="/assets/images/icons/primary-check-icon.svg"
                alt=""
                className=""
                style={
                  formik.values.firstName && !formik.errors.firstName
                    ? { display: "block" }
                    : { display: "none" }
                }
              />
            }
          />
        </div>
        {formik.touched.firstName && formik.errors.firstName ? (
          <div className="error-message">{formik.errors.firstName}</div>
        ) : null}
      </CreateProfileCardWrapper>
      <CreateProfileCardWrapper>
        <h5 className="d-flex align-items-center justify-content-between">
          {t("aboutYou.step1.ques2.title")}
          <Button
            className="border-0 bg-tranaparent w-auto h-auto shadow-none p-0 info-icon-btn"
            onClick={() => {
              dispatch(setInfoContent(t("aboutYou.resources.1")));
            }}
          >
            <img
              src="/assets/images/icons/info-circle-icon.svg"
              alt=""
              className="img-fluid"
            />
          </Button>
        </h5>
        <div className="custom-radio-select-button custom-radio-select-custom">
          <Radio.Group
            name="ageRange"
            value={formik.values.ageRange}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          >
            {ageRanges.map((range, index) => (
              <Radio.Button key={index} value={range.value}>
                {range.label}
              </Radio.Button>
            ))}
          </Radio.Group>
        </div>
        {formik.touched.ageRange && formik.errors.ageRange ? (
          <div className="error-message">{formik.errors.ageRange}</div>
        ) : null}
      </CreateProfileCardWrapper>
    </>
  );
};

export default NameAgePage;
